module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1021-4f177aa64d613195bb427a227dcb99c5.png";